import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import scrollLock from 'scroll-lock';


gsap.registerPlugin(Flip, ScrollTrigger);

window.boldLoaderInit = function boldLoaderInit() {
  if (document.querySelector('.bold-loader')) {
    window.scrollTo(0, 0);

    if (window.innerWidth > 1024) {
      window.scrollTo(0, 0);
      scrollLock.disablePageScroll();

      gsap.registerPlugin(Flip);

      let flipCtx;

      const headerEl = document.querySelector('.header');
      const boldLoaderEl = document.querySelector('.bold-loader');
      const loaderContentEl = boldLoaderEl.querySelector('.bold-loader__content');
      const logoWr = loaderContentEl.querySelector('.bold-loader__logo-wr');
      const logo = loaderContentEl.querySelector('.bold-loader__logo');
      const firstSec = document.querySelector('.home-page-sec');

      const duration = 2000;

      if (headerEl) {
        headerEl.classList.add('bold-loader-animation');
      }

      if (logo) {
        const paths = logo.querySelectorAll('path');
        const letterPaths = Array.from(paths).slice(0, -3);
        const logoPaths = Array.from(paths).slice(-3);

        const centerIndex = (letterPaths.length - 1) / 2;

        gsap.set(letterPaths, {
          x: (i) => (i - centerIndex) * 30,
        });

        gsap.set(logoPaths, {
          opacity: 0,
          x: -50,
        });

        gsap.to(letterPaths, {
          duration: 0.8,
          x: 0,
          ease: "power2.inOut",
          delay: 0.5,
          onComplete: () => {
            gsap.to(logoPaths, {
              duration: 0.8,
              x: 0,
              opacity: 1,
              ease: "power2.out",
            });
          },
        });
      }

      function logoStartAnimation() {
        logo.classList.add('is-start-animated');
        logoWr.classList.add('is-start-animated');

        setTimeout(function () {
          logo.classList.add('is-end-animated');
          logoWr.classList.add('is-end-animated');
        }, duration / 2);
      }

      function headerLogoAnimation() {
        if (headerEl) {
          headerEl.classList.add('is-bold-loader-animated');
        }
      }

      function removeHeaderLogoAnimation() {
        if (headerEl) {
          headerEl.classList.remove('is-bold-loader-animated');
          headerEl.classList.remove('bold-loader-animation');
          firstSec.classList.add('animated');
          firstSec.querySelector('.first-sec__title').classList.add('title-animation');
        }
      }

      boldLoaderEl.classList.add('is-start-animated');

      setTimeout(() => {
        logoStartAnimation();
      }, 0);

      const startAnimationMoveLogo = () => {
        flipCtx && flipCtx.revert();

        flipCtx = gsap.context(() => {
          const logo = document.querySelector('.bold-loader__logo');

          const durationGSAP = 1.2;

          gsap.to(logo, {
            duration: duration / 1000,
            scale: 1,
            ease: 'power2.inOut',
            onComplete: () => {
              const startState = Flip.getState(logo);

              boldLoaderEl.classList.add('is-start-finish-animated');

              headerLogoAnimation();

              document.querySelector('.bold-loader__logo-end').appendChild(logo);

              Flip.from(startState, {
                duration: durationGSAP,
                ease: 'power2.inOut',
              });

              gsap.to(logo, {
                duration: durationGSAP + 0.3,
                scale: 1,
                ease: 'power2.inOut',
              });

              setTimeout(function () {
                boldLoaderEl.classList.add('is-end-finish-animated');

                setTimeout(function () {
                  boldLoaderEl.style.pointerEvents = 'none';
                  scrollLock.clearQueueScrollLocks();
                  scrollLock.enablePageScroll();
                  removeHeaderLogoAnimation();
                }, 200);
              }, durationGSAP * 1000 + 100);
            },
          });
        });
      };

      setTimeout(() => {
        startAnimationMoveLogo();
      }, duration / 2 + 300);
    } else {
      setTimeout(() => {
        const firstSec = document.querySelector('.home-page-sec');

        firstSec.querySelector('.first-sec__title').classList.add('title-animation');
        firstSec.querySelector('.first-sec__button').classList.add('animated');
      }, 100)
    }
  }
};


boldLoaderInit();





